/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

const search = (root, guid) => {
    const stack = [root];
    while (stack.length) {
        const node = stack.shift();
        if (!node) {
            return;
        }
        if (node.guid === guid) {
            return node;
        }
        node.children && stack.push(...node.children);
    }
};
const getParentNodes = (root, guid, parents) => {
    const parentNode = search(root, guid);
    parents.push(parentNode);
    if (parentNode && parentNode.parent) {
        parents = getParentNodes(root, parentNode.parent, parents);
    }
    return parents;
};
const getParentGuids = (root, guid) => {
    const parentGuids = [guid];
    const selectedNode = search(root, guid);
    if (selectedNode) {
        if (selectedNode.parent) {
            const parentNodes = getParentNodes(root, selectedNode.parent, []);
            for (const node of parentNodes) {
                if (node) {
                    parentGuids.push(node.guid);
                }
            }
        }
    }
    return parentGuids;
};

export { getParentGuids };
